import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Aux from '../../../components/Hoc/Aux';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import ReasonsResults from '../../../components/Reasons/ReasonsResults';
import * as RouteHelpers from '../../../helpers/routes';

import _ from 'lodash';

class Essential extends Component {
  constructor (props) {
    super(props);
    this._goToIndividualQuote = this._goToIndividualQuote.bind(this);
  }

  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Prospect - Essential',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Essential',
      'eventValue': undefined
    });
  }

  _goToIndividualQuote () {
    const p = _.clone(this.props);

    p.setFieldValue('FamilyType', 'Individual');
    p.setFieldValue('Quote', 'individuals');
    p.setStep(2);
    RouteHelpers.history.push('/essential/find-a-plan/2');
  }

  render () {
    return (
      <Aux>
        <ReasonsResults type='essential' intro='true' />
        <DocSearch search='https://findadoc.cdphp.com/?PlanType=Essential Plan' />
        <section className='divide p60'>
          <div className='wrap'>
            <h2>Find out if you qualify.</h2>
            <ul className='inline'>
              <li><Link to='/essential/find-a-plan/zip?skip=true' className='btn alt'>For Just Me</Link></li>
              <li>
                <Link
                  to='/essential/family/find-a-plan'
                  params={{family: 'hello'}}
                  className='btn alt'>For My Family</Link></li>
            </ul>
          </div>
        </section>
      </Aux>
    );
  }
}

Essential.propTypes = { // validate props expected
};

export default Essential;



// WEBPACK FOOTER //
// ./src/containers/Views/Landing/Essential.jsx